import { makeStyles } from '@material-ui/core';

export const useSearchInputAdornmentStyle = makeStyles({
  positionEnd: {
    color: '#ccc',
    padding: '5px',
    margin: '-5px',
    '& button': {
      padding: '2px 11px',
    },
    '& button:hover': {
      backgroundColor: 'transparent',
    },
  },
  positionStart: {
    color: '#333',
    padding: '0 5px 0 15px',
    cursor: 'pointer',
  },
});
